// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "RewardDetailsTabsDesktop__textCenter__FUnL+";
export const tabs = "RewardDetailsTabsDesktop__tabs__heHlV";
export const tab = "RewardDetailsTabsDesktop__tab__SWlSK";
export const active = "RewardDetailsTabsDesktop__active__69yd1";